import React from 'react'
import TimeInput from '../../../../Components/TimeInput'
import { SITTINGS } from '../utils/sittingTimeValidation'

export function SittingTimesEditor({ sittingTimes, onSittingTimeChange, errors }) {
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Menu Sitting Times</h3>
        <p className="mt-1 text-sm text-gray-500">Configure when each menu sitting is available</p>
      </div>
      <div className="px-4 py-5 sm:p-6">
        {errors.length > 0 && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
            <ul className="text-sm text-red-700 list-disc list-inside">
              {errors.map((error, i) => (
                <li key={i}>{error}</li>
              ))}
            </ul>
          </div>
        )}
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sitting</th>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start Time</th>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End Time</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {SITTINGS.map(({ key, label }) => {
              const times = sittingTimes[key] || {}
              return (
                <tr key={key}>
                  <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {label}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <TimeInput
                      value={times.start}
                      onChange={(e) => onSittingTimeChange(key, 'start', e.target.value)}
                    />
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <TimeInput
                      value={times.end}
                      onChange={(e) => onSittingTimeChange(key, 'end', e.target.value)}
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <p className="mt-4 text-sm text-gray-500">
          Note: Dinner time can cross midnight (e.g., 16:00 to 04:59 next day).
        </p>
      </div>
    </div>
  )
}
